<template>
  <div class="app-wrapper">
    <div class="main-container">
      <tenantbar v-if="navShow"/>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { Tenantbar } from './components'
import request from '@/utils/request'

export default {
  data(){
    return{
      navShow:true,
      us:{},
      tenantId:'',
      resource:'',
    }
  },
  name: 'LayoutT',
  inject:['reload'],
  components: {
    Tenantbar
  },
  computed: {
  },
  created(){
    this.getinfo();
  },
  watch: {
      $route(to, from) {
        if(to.path == '/'){
            this.$confirm('抱歉，账号异常，已为您退出该账号', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            cancelButtonClass: 'messageBox-btnF',
            confirmButtonClass: 'messageBox-btnT',
            type: 'warning',
            }).then(() => {
                this.$store.dispatch('LogOutT').then(() => {
                  this.reload() // 为了重新实例化vue-router对象 避免bug
                  this.$router.push({path:'/infoTenant?tenantNum='+this.tenantId});
                })
            }).catch(() => {
                this.$store.dispatch('LogOutT').then(() => {
                  this.reload() // 为了重新实例化vue-router对象 避免bug
                  this.$router.push({path:'/infoTenant?tenantNum='+this.tenantId});
                })
            });
        }
      }
  },
  methods: {
    //获取info
    getinfo(){
      request({
        method:'get',
        url:'auth/info'
      }).then(res=>{
        this.us = res.jwtUser
        this.tenantId = res.tenant.id
        this.resource = res.resource
        if(res.tenant.tenantNav == 0){
          this.navShow = false
        }
      }).catch(err=>{
        this.$confirm('当前帐户已登录到另一个设备上，或不在使用时间内', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'messageBox-btnF',
          confirmButtonClass: 'messageBox-btnT',
          type: 'warning',
        }).then(() => {
          this.LogOutT();
        }).catch(() => {
          this.LogOutT();
        })
      })
    },
    LogOutT() {
        if(this.tenantId == 13){
            this.$store.dispatch('LogOutT').then(() => {
            this.reload() // 为了重新实例化vue-router对象 避免bug
            this.$router.push({path:'/party'});
            })
        }else if(this.tenantId == 25 || this.tenantId == 19){
            this.$store.dispatch('LogOutT').then(() => {
            this.reload() // 为了重新实例化vue-router对象 避免bug
            this.$router.push({path:'/partyM'});
            })
        }else if(this.tenantId == 34){
            this.$store.dispatch('LogOutT').then(() => {
            this.reload() // 为了重新实例化vue-router对象 避免bug
            this.$router.push({path:'/partyHN'});
            })
        }else if(this.resource !== null){
            this.$store.dispatch('LogOutT').then(() => {
            this.reload() // 为了重新实例化vue-router对象 避免bug
            this.$router.push({path:'/partyM'});
            })
        }else{
            this.$store.dispatch('LogOutT').then(() => {
            this.reload() // 为了重新实例化vue-router对象 避免bug
            this.$router.push({path:'/infoTenant?tenantNum='+this.tenantId});
            })
        }
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    width: 100%;
  }
  .app-main{
    background: #f5f5f5;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/LayoutT.vue